import { render } from "./StatusLevelCitizen.vue?vue&type=template&id=fa058dda&scoped=true"
import script from "./StatusLevelCitizen.vue?vue&type=script&lang=js"
export * from "./StatusLevelCitizen.vue?vue&type=script&lang=js"

import "./StatusLevelCitizen.vue?vue&type=style&index=0&id=fa058dda&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa058dda"]])

export default __exports__